import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { openBoardSettings } from '../../../../../../base/effects/openBoardSettings';
import { scrollPanelToSection } from '../../../../../asidePanel/helpers/scrollPanelToSection';
import { CLASS_BOARD_DETAILS_SECTION } from '../../../../../boardDetails/constants';
import { SegmentBoardSettingsSourceValue } from '../../../../../../../../middlewares/segment/trackEntities/boardEvents';
import { EBoardSetting } from '../../../../../boardDetails/details/TabDetails/components/TabDetails/types';

export const onOpenBoardSettings = (): ThunkAction => {
    return (dispatch: Dispatch) => {
        dispatch(openBoardSettings(EBoardSetting.APP_NOTIFICATIONS, SegmentBoardSettingsSourceValue.CARD_WATCH_SETTINGS));
        //wait until board settings are opened
        setTimeout(() => {
            scrollPanelToSection(
                `.${CLASS_BOARD_DETAILS_SECTION}--notifications`,
                null,
                {current: null});
            setTimeout(() => {
                const className = 'board-details__push-notifications-item';
                const item = document.querySelector('.' + className + '--watch');
                if (item) {
                    item.classList.add(className + '--blink');
                }
            }, 300);
        }, 0);
    };
};
